import template from './component.tpl.html';
import NotificationBellController from './controller';

/**
 * @ngdoc component
 * @name theme.festzelt-os.component:header
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <layout-header></layout-header>
 *
 */
angular
    .module('festzelt-os.theme.festzelt-os')
    .component('alNotificationBell', {
        templateUrl: template,
        controllerAs: 'vm',
        controller: NotificationBellController,
        bindings: {
            fetch: '@',
            guestlistId: '<',
            und: '&',
            onCloseTriggered: '&'
        }
    });



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-notification-bell/component.js